module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/10IYylY/tc-custom/9781685503239.jpg?1723405902706",
      "alt": "This image is the cover for the book Eight Months Without You"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Eight Months Without You\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Can Sami and Joakim’s relationship survive accusations of cheating, a thrown wineglass, and eight months of silence?"), _c('br'), _c('br'), _vm._v("Hurtful words and a thrown wineglass in a fit of jealousy tear Sami and Joakim apart; fiery tempers and stubbornness keep them from making up. But then, after eight months without a single word, just as Sami is about to make the first move, Joakim shows up, eager to make things right."), _c('br'), _c('br'), _vm._v("Can they overcome accusations of cheating and eight months of silence? Are conversations, confessions, and planning for the future enough? Will the love they still share conquer all?")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Nell Iris\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0